import loaded from '@/scripts/helpers/loaded';

loaded(() => {
    const elements = Array.from(document.querySelectorAll('[data-ajax-content]'));
    if (!elements) {
        return;
    }

    if (!elements?.length) {
        return;
    }

    elements.forEach((parent) => {
        const id = parent.getAttribute('data-id');
        let url;
        
        if (id === 'shipping') {
            url = '/pages/shipping-returns-json';
        } else if (id === 'why_buy') {
            url = '/pages/why-buy-from-us-json';
        } else if (id === 'our_promise'){
            url = '/pages/our-promise-json';
        }
        
        if (url) {
            fetch(url)
                .then(response => response.text())
                .then(data => {
                    const hideContent = parent.querySelector('.js__hide_content');
                    if (hideContent) {
                        hideContent.innerHTML += data;
                        const parentContent = hideContent.querySelector('.js__parent__content');
                        if (parentContent) {
                            parent.innerHTML = parentContent.innerHTML;
                        }
                    }
                })
                .catch(error => {
                    console.error('Error fetching content:', error);
                });
        }
    });
});
